<template>
	<c-dialog ref="dialog" title="报工详情" mode="slide" width="1000" mask-close :button="false">
		<template #head>
			<div class="m-detail-tag flex-center-cross">
				<c-state dict="outputTypeDic" tag :value="detailData.output_type"></c-state>
				<c-state dict="auditStateDic" tag :value="detailData.state"></c-state>
			</div>
		</template>

		<div class="m-detail-box">
			<c-detail column="2">
				<c-detail-item label="关联工单">
					<c-link v-if="auth('m_work')" @click="globalDialog('workDetail', {props: {id: detailData.work_id}})">{{detailData.work_code}}</c-link>
					<span v-else>{{detailData.work_code}}</span>
				</c-detail-item>
				<c-detail-item label="关联任务">
					<c-link v-if="auth('m_task')" @click="globalDialog('taskDetail', {props: {id: detailData.task_id}})">{{detailData.process_code}} [{{detailData.process_name}}]</c-link>
					<span v-else>{{detailData.process_code}} [{{detailData.process_name}}]</span>
				</c-detail-item>

				<c-detail-item label="生产人员">
					{{detailData.output_user_realname}}
				</c-detail-item>
				<c-detail-item label="报工数">
					<span>{{detailData.aux_output_count}}</span>
					(
						<font style="color:green;font-weight: 400;">良：{{detailData.aux_fine_count}}</font> /
						<font style="color:red;font-weight: 400;">不良：{{detailData.aux_defects_count}}</font>
					)
				</c-detail-item>
				<c-detail-item label="报工单位">
					{{detailData.aux_unit}}
				</c-detail-item>
				<!-- <c-detail-item label="单位转换率" >
					{{detailData.aux_unit_count}}
				</c-detail-item> -->
				
				<c-detail-item label="产品报工数" v-if="detailData.output_count != detailData.aux_output_count">
					<span>{{detailData.output_count}}</span>
					(
						<font style="color:green;font-weight: 400;">良：{{detailData.fine_count}}</font> /
						<font style="color:red;font-weight: 400;">不良：{{detailData.defects_count}}</font>
					)
				</c-detail-item>
				<c-detail-item v-if="defectsList.length" label="不良品项">
					{{defectsList.map(item => `${item.defects_name}(${item.item_count})`).join('、')}}
				</c-detail-item>
				<c-detail-item label="报工良品率">
					{{detailData.fine_ratio}}%
				</c-detail-item>
				<c-detail-item label="产品编号">
					{{detailData.product_code}}
				</c-detail-item>
				<c-detail-item label="产品名称">
					{{detailData.product_name}}
					<span v-if="detailData.product_spec"> [{{detailData.product_spec}}]</span>
				</c-detail-item>
				<c-detail-item label="产品来源">
					<c-state dict="productSourceName" :value="detailData.product_source"></c-state>
				</c-detail-item>
				<c-detail-item label="产品类型">
					<c-state dict="productTypeName" :value="detailData.product_type"></c-state>
				</c-detail-item>
				<c-detail-item label="产品单位">
					{{detailData.unit}}
				</c-detail-item>
				<c-detail-item label="计价方式">
					<c-state dict="pricingTypeDic" :value="detailData.pricing_type"></c-state>
				</c-detail-item>
				<c-detail-item label="工资单价">
					{{detailData.price}}元
				</c-detail-item>
				<c-detail-item label="预计工资">
					{{detailData.pre_salary}}元
				</c-detail-item>
				<c-detail-item label="报工开始时间">
					{{detailData.real_start_date}}
				</c-detail-item>
				<c-detail-item label="报工结束时间">
					{{detailData.real_end_date}}
				</c-detail-item>
				<c-detail-item label="创建人">
					{{detailData.create_user_realname}}
				</c-detail-item>
				<c-detail-item label="创建时间">
					{{detailData.create_date}}
				</c-detail-item>
				<c-detail-item label="检验方式">
					<c-state dict="testModeDic" :value="detailData.test_mode"></c-state>
				</c-detail-item>
				<c-detail-item label="检验状态">
					<c-state dict="testStateDic" :value="detailData.test_state"></c-state>
				</c-detail-item>
				<template v-if="detailData.test_state == 3">
					<c-detail-item label="质检人">
						{{detailData.test_user_realname}}
					</c-detail-item>
					<c-detail-item label="质检时间">
						<span>{{detailData.test_date}}</span>
					</c-detail-item>
					<c-detail-item label="质检数">
						<span>{{detailData.test_count}}</span>
					</c-detail-item>
					<c-detail-item label="质检合格数">
						<span>{{detailData.test_fine_count}}</span>
					</c-detail-item>
					<c-detail-item label="质检不合格数">
						<span>{{detailData.test_defects_count}}</span>
					</c-detail-item>
					<c-detail-item label="质检良品率">
						<span>{{detailData.test_fine_ratio}}%</span>
					</c-detail-item>
				</template>
				
				<c-detail-item v-if="detailData.ref_code" label="关联单据">
					<order-link :type="detailData.ref_type" :id="detailData.ref_id" :code="detailData.ref_code"></order-link>
				</c-detail-item>
				<custom-detail work-type="14" :data="detailData.custom_fields_value_json"></custom-detail>
			</c-detail>
			<c-title v-if="detailData.test_state == 3">质检不合格处理信息</c-title>
			<c-table v-show="detailData.test_state == 3" ref="test_defects_table" border :paging="false">
				<template #empty>
					<c-empty message="当前报工无质检不合格数据"></c-empty>
				</template>
				<c-table-column label="处理数量" width="80">
					<template #default="{data}">
						{{data.test_defects_count}}
					</template>
				</c-table-column>
				<c-table-column label="处理方式" width="70">
					<template #default="{data}">
						<c-state dict="afterTypeDic" :value="data.after_type"></c-state>
					</template>
				</c-table-column>
				<c-table-column label="处理状态" width="70">
					<template #default="{data}">
						<c-state dict="afterStateDic" :value="data.after_state"></c-state>
					</template>
				</c-table-column>
				<c-table-column label="不合格原因" width="380">
					<template #default="{data}">
						{{data.defects_reasons}}
					</template>
				</c-table-column>
				<c-table-column label="备注" width="180">
					<template #default="{data}">
						{{data.remark}}
					</template>
				</c-table-column>
				<c-table-column label="发现日期" width="140">
					<template #default="{data}">
						{{data.discovery_date}}
					</template>
				</c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'outputDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {},
				taskData: {},
				defectsList: []
			}
		},

		methods: {
			open() {
				this.request({
					url: '/output/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.taskData = data.taskInfo;
						this.defectsList = data.defectsList || [];
						this.$refs.test_defects_table.setData(data.testDefectsList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>